const defaultRawFrequencies = [
  { every: 1, period: 1 }, // 1 Day
  { every: 1, period: 2 }, // 1 Week
  { every: 2, period: 2 }, // 2 Weeks
  { every: 3, period: 2 }, // 3 Weeks
  { every: 1, period: 3 }, // 1 Month
  { every: 2, period: 3 }, // 2 Months
  { every: 3, period: 3 }, // 3 Months
  { every: 4, period: 3 }, // 4 Months
  { every: 5, period: 3 }, // 5 Months
  { every: 6, period: 3 }, // 6 Months
  { every: 7, period: 3 }, // 7 Months
  { every: 8, period: 3 }  // 8 Months
];

module.exports = function FrequencyProvider() {
  this.raw = defaultRawFrequencies;

  this.override = function(_raw) {
    this.raw = _raw;
  };

  this.$get = function(Frequency) {
    return this.raw.map(freq => new Frequency(freq.every, freq.period));
  };

  this.$get.$inject = ['Frequency'];
};
